module.exports = __webpack_public_path__ + "bb078da163b527e5f98a11b1d7524919.svg";